export default __webpack_public_path__ + "static/media/1516 cutlery side.be948806.png";